<section id="novita">
  <div class="container py-5">
    <h2 class="text-secondary mb-4">In evidenza</h2>
    <div class="row g-4">
      <ng-container *ngFor="let news of data.news_loader_news">
        <div class="col-md-6 col-xl-4">
          <div class="card-wrapper border border-light rounded shadow-sm">
            <div class="card no-after rounded">
              <div class="img-responsive-wrapper" *ngIf="news && news.news_image && news.news_image.field_media_image">
                <div class="img-responsive img-responsive-panoramic">
                  <figure class="img-wrapper">
                    <img
                      [src]="news?.news_image?.field_media_image?.uri?.url ? getImage(news?.news_image?.field_media_image?.uri?.url, 'hero') : ''"
                      [title]="news?.news_image?.field_media_image?.meta?.title"
                      [alt]="news?.news_image?.field_media_image?.meta?.alt">
                  </figure>
                </div>
              </div>
              <div class="card-body">
                <div class="category-top">
                  <a class="category text-decoration-none"
                    [href]="'/novita/'+news.news_type?.field_breadcrumb">{{news.news_type?.name}}</a>
                  <span class="data text-secondary">{{news.news_publication_date | date:"dd MMM yyyy"}}</span>
                </div>
                <a [href]="news.path.alias" class="text-decoration-none" data-element="news-category-link">
                  <h3 class="card-title"> {{news.title}}</h3>
                </a>
                <p class="card-text text-secondary" [innerHTML]="stringSubstr(news.news_description,0,255)"></p>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="bg-grey-card py-5">
    <div class="container" #top>
      <h2 class="text-secondary mb-4">Esplora tutte le novità</h2>
      <app-input-search (searchEvent)="onSearch($event)"></app-input-search>
      <div class="row g-4" *ngIf="!isLoading">
        <div class="col-md-6 col-xl-4" *ngFor="let news of allNews">
          <div class="card-wrapper border border-light rounded shadow-sm">
            <div class="card no-after rounded">
              <div class="img-responsive-wrapper" *ngIf="news && news.news_image && news.news_image.field_media_image">
                <div class="img-responsive img-responsive-panoramic">
                  <figure class="img-wrapper">
                    <img
                    [src]="news?.news_image?.field_media_image?.uri?.url ? getImage(news?.news_image?.field_media_image?.uri?.url, 'hero') : ''"
                    [title]="news?.news_image?.field_media_image?.meta?.title"
                    [alt]="news?.news_image?.field_media_image?.meta?.alt">
                  </figure>
                </div>
              </div>
              <div class="card-body">
                <div class="category-top">
                  <a class="category text-decoration-none"
                    [href]="'/novita/'+news.news_type?.field_breadcrumb">{{news.news_type?.name}}</a>
                  <span class="data">{{news.news_publication_date | date:"dd MMM yyyy"}}</span>
                </div>
                <a [href]="news.path.alias" class="text-decoration-none" data-element="news-category-link">
                  <h3 class="card-title">{{news.title}}</h3>
                </a>
                <p class="card-text pb-3 text-secondary" [innerHTML]="stringSubstr(news.news_description,0,255)"></p>

              </div>
            </div>
          </div>
        </div>
        <!--end card-->
      </div>
      <div class="row">
        <div class="d-flex justify-content-center align-items-center" *ngIf="isLoading">
          <div class="progress-spinner progress-spinner-active spinner-lg">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
      <ng-container *ngIf="paginatorVisible && !isLoading && allNews.length">
        <app-paginator [currentPage]="currentPage" [totalPages]="totalPages" (pageChanged)="onPageChange($event)">
        </app-paginator>
      </ng-container>
    </div>
  </div>
  <div class="container py-5" id="argomento">
    <h2 class="text-secondary mb-4">Esplora per categoria</h2>
    <div class="row g-4">

      <ng-container *ngFor="let category of data.news_loader_categories">
        <div class="col-md-6 col-xl-4">
          <div class="cmp-card-simple card-wrapper pb-0 rounded border border-light">
            <div class="card shadow-sm rounded">
              <div class="card-body">
                <a [href]="category?.alias" class="text-decoration-none" data-element="news-category-link">
                  <h3 class="card-title t-primary title-xlarge">{{category?.title}}</h3>
                </a>
                <p class="text-secondary mb-0">{{category?.description}}</p>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</section>